export function announce(type: 'polite' | 'assertive', message: string) {
	const target = document.getElementById(`at-announce-${type}`)

	if (target instanceof HTMLElement) {
		target.innerText = message
	}
}
